import React from "react";
import { Box } from "@mui/material";

const AvatarUser = ({
  img,
  noMargin,
  mRight,
  onClick = null,
}) => {
  return (
    <Box
      onClick={onClick}
      sx={{
        boxSizing: "border-box",
        minHeight: "67px",
        height: "67px",
        minWidth: "67px",
        width: "67px",
        borderRadius: "100%",
        backgroundColor: "#f0f0f0",
        marginRight: noMargin ? 0 : (mRight ?? "10px"),
        padding: "5px",
        position: "relative",
        overflow: "hidden",
        cursor: onClick ? "pointer" : "default",
      }}
    >
      <Box
        component="img"
        src={img}
        alt="avatar"
        sx={{
          width: "100%",
          height: "100%",
          borderRadius: "50%",
          objectFit: "cover",
        }}
      />
    </Box>
  );
};

export default AvatarUser;
